import { motion } from "framer-motion";

import { styles } from "../styles";

const Hero = () => {
  return (
    <section className={`relative w-full h-screen mx-auto`}>
      <div
        className={`justify-center items-center text-center  ${styles.paddingX} flex flex-row gap-5`}
      >
        <div className="mt-64">
          <h1 className={`${styles.heroHeadText} text-white`}>
            AI-Powered Design: Voice to Vision in Seconds
          </h1>
          <p className={`${styles.heroSubText} mt-2 text-white-100`}>
            Streamlining design processes using speech/text in AEC industry
          </p>
        </div>
      </div>

      {/* <ComputersCanvas /> */}

      <div className="absolute xs:bottom-10 bottom-32 w-full flex justify-center items-center">
        <a href="#usecases">
          <div className="w-[35px] h-[64px] rounded-3xl border-4 border-secondary flex justify-center items-start p-2">
            <motion.div
              animate={{
                y: [0, 24, 0],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                repeatType: "loop",
              }}
              className="w-3 h-3 rounded-full bg-secondary mb-1"
            />
          </div>
        </a>
      </div>
    </section>
  );
};

export default Hero;
